import { Controller } from "@hotwired/stimulus"
import { toPng } from "html-to-image"

// Connects to data-controller="feedback-export"
export default class extends Controller {
  static targets = ["capture"]
  static values = {
    excludeClass: {
      type: String,
      default: "export-exclude"
    }
  }

  download(event) {
    event.preventDefault()

    if (!this.hasCaptureTarget) return

    const isFirefox = navigator.userAgent.toLowerCase().includes('firefox')

    toPng(this.captureTarget, {
      filter: this.excludeFilter.bind(this),
      skipFonts: isFirefox
    })
      .then(this.saveImage.bind(this))
      .catch((error) => {
        console.error(error)
      })
  }

  excludeFilter(node) {
    return !node.classList || !node.classList.contains(this.excludeClassValue)
  }

  saveImage(dataUrl) {
    const link = document.createElement('a')
    link.download = this.getFileName()
    link.href = dataUrl
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  getFileName() {
    return `${this.captureTarget.dataset.fileName}.png` || "feedback.png"
  }
}
